import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';
import { mapSupabaseError } from '../../utils/supabaseErrors';
import { PasswordInput } from '../shared/PasswordInput';
import './LoginPage.css';

export function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // supabase-js establishes a recovery session from the email link and fires
    // PASSWORD_RECOVERY. Show the form once a (recovery) session exists; if the
    // event already fired before mount, getSession() still finds the session.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true);
    });
    supabase.auth.getSession().then(({ data }) => { if (data?.session) setReady(true); });
    return () => subscription?.unsubscribe();
  }, []);

  const isFormValid = password.length >= 8 && password === confirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) throw updateError;
      await supabase.auth.signOut();
      navigate('/login', { state: { message: 'Password updated. Please log in.' } });
    } catch (err) {
      setError(mapSupabaseError(err));
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>WeGolden</h1>
        <p className="subtitle">Reset Password</p>

        {!ready ? (
          <p className="info-message">Open this page from the password reset link in your email.</p>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label htmlFor="new-password">New Password</label>
              <PasswordInput
                id="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                autoComplete="new-password"
                ariaDescribedBy="new-password-hint"
              />
              <small id="new-password-hint">Minimum 8 characters</small>
            </div>
            <div className="form-group">
              <label htmlFor="confirm-password">Confirm Password</label>
              <PasswordInput
                id="confirm-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
            {error && <div className="error-message" role="alert">{error}</div>}
            <button type="submit" className="btn-primary" disabled={loading || !isFormValid}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
